import { useState, useEffect } from "react";
import { useGetAllBookQuery } from "src/services/BookService";

const useBook = () => {
    const [book, setBook] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllBookQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setBook(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { book, isDataLoading };
};

export default useBook;
